import {TransportCategory, transportCategory} from "@ots-frontend/ots-data";
import {Group, Text} from "@mantine/core";
import {IconDropletFilled} from "@tabler/icons-react";
import {useMemo} from "react";
import {FormattedDatabaseCode} from "../../../text/FormattedDatabaseCode/FormattedDatabaseCode";

export const TransportCategoryCell = (props: { category?: TransportCategory }) => {
  const {category} = props

  const textColorRef = useMemo(() => {
    if (category === transportCategory.oil) {
      return "transport-category-oil"
    } else if (category === transportCategory.water) {
      return "transport-category-water"
    } else {
      return undefined
    }
  }, [category])

  if (!category) {
    return null
  }

  return (
    <Text c={textColorRef}>
      <Group spacing="xs">
        <Text c={textColorRef}>
          <IconDropletFilled size={14}/>
        </Text>
        <FormattedDatabaseCode value={category}/>
      </Group>
    </Text>
  )
}
